import NewsRoom from "../../../../../../plugins/wwp-newsroom/public/js/wwp-newsroom";

export default class ChildNewsRoom extends NewsRoom {

  init() {
    super.init();
    this.registerUniversFilter();
    this.registerImageModals(this.element);
  }

  registerUniversFilter() {
    const $universNav = $('.card-filters-list'),
      activeClass = 'is-active';
    if ($universNav.length) {
      $universNav.find('a').on('click', (e) => {
        e.preventDefault();
        const $previouslyActive = $universNav.find('.' + activeClass),
          $currentTarget = $(e.currentTarget),
          wantToDeselect = ($previouslyActive[0] === $currentTarget[0]);

        $previouslyActive.removeClass(activeClass);
        let urlToLoad = '';
        if (wantToDeselect) {
          urlToLoad = e.currentTarget.href.split('?')[0];
        } else {
          urlToLoad = e.currentTarget.href;
          $(e.currentTarget).addClass(activeClass);
        }
        this.loadPage(urlToLoad, false, ($newContext, $newItems) => {
          this.newPageLoaded($newContext, $newItems)
        });
      });
    }
  }

  handleNewContext($newContext, isPagination, cb) {
    super.handleNewContext($newContext, isPagination, cb);
    this.replaceSearch($newContext.find('form.newsroom-filters'));

  }

  replaceSearch($newSearch) {
    this.element.find('form.newsroom-filters').replaceWith($newSearch);
    this.registerSearch(true);
  }

  registerImageModals($context) {
    $context.find('.media-image').modaal({
      type: 'image',
      custom_class: 'modal-lightbox'
    });
  }

  newPageLoaded($newContext, $newItems) {
    this.registerImageModals($newItems);
  }
}

window.pew.addRegistryEntry({key: 'wwp-newsroom', classDef: ChildNewsRoom, domSelector: '.module-newsroom'});
